mainCtrl.$inject = ['$rootScope', '$uibModal', '$state', 'configuration', 'auth', '_build']

//////////////////////////////////////
// Top-level controller for the app //
//////////////////////////////////////
export default function mainCtrl($rootScope, $modal, $state, config, auth, _build) {
  var _self = this
  this.config = config
  this._build = _build
  this.year = new Date().getFullYear()

  this.init = function(goHome) {
    auth.getCurrentUser().then(
      function(user) {
        _self.user = user
        if (goHome) {
          $state.go('home')
        }
      },
      function(reason) {
        _self.user = null
        $state.go('sign-in')
      }
    )
    _self.csrfToken = auth.getCsrfToken()
  }

  this.searchByEmail = function(email) {
    $state.go('user-info', { email: email })
  }

  // Auth related functions
  this.signIn = function() {
    _self.authLoading = true
    auth.signIn(this.email, this.password, this.csrfToken).then(
      function(userUuid) {
        _self.email = null
        _self.password = null
        _self.init(true)
        _self.authLoading = false
      },
      function(reason) {
        _self.password = null
        _self.signInError = reason
        _self.authLoading = false
      }
    )
  }

  this.signOut = function() {
    _self.authLoading = true
    _self.email = null
    _self.password = null
    auth.signOut().then(
      function(status) {
        _self.init()
        _self.authLoading = false
      },
      function(reason) {
        console.log(reason)
        _self.authLoading = false
        _self.signOutError = reason
      }
    )
  }

  this.signInRack = function(userUuid) {
    _self.authLoading = true
    auth.signInRack(userUuid).then(
      function(userUuid) {
        alert('Signed in as ' + userUuid)
        _self.authLoading = false
      },
      function(reason) {
        console.log(reason)
        _self.authLoading = false
      }
    )
  }

  $rootScope.$on('Unauthenticated', function() {
    $state.go('sign-in')
  })

  $rootScope.$on('Unauthorized', function(evt, resp) {
    $modal.open({
      template: `<div class="modal-header">
          <h4 class="modal-title">You are not authorized to perform this action</h4>
        </div>
        <div class="modal-body">
          <pre class="alert alert-danger">${JSON.stringify(resp, null, 2)}</pre>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" ng-click="$close()">OK</button>
        </div>`
    })
  })
}
